import type { FC } from "react";
import { useProviders } from "../providers/useProviders";
import { Select } from "../../components/select/Select";

interface Props {
  readonly providerId: string | undefined;
  readonly onChange: (providerId: string) => void;
  readonly disabled?: boolean;
  readonly size?: "small" | "medium";
}

const ProviderSelect: FC<Props> = ({ providerId, onChange, disabled, size }) => {
  const { providers } = useProviders();
  return (
    <Select
      label="Dostawca"
      fullWidth
      values={providers.map((p) => ({ value: p.id, label: p.name }))}
      value={providerId ?? ""}
      onSelect={onChange}
      disabled={disabled}
      size={size}
    />
  );
};

export default ProviderSelect;
